import { render, staticRenderFns } from "./jianyanku.vue?vue&type=template&id=6796f429&scoped=true"
import script from "./jianyanku.vue?vue&type=script&lang=ts"
export * from "./jianyanku.vue?vue&type=script&lang=ts"
import style0 from "./jianyanku.vue?vue&type=style&index=0&id=6796f429&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6796f429",
  null
  
)

export default component.exports